var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientSites != null && _vm.selectedSite != null)?_c('div',{staticClass:"client-sites"},[_c('vue-select',{key:"client-sites",attrs:{"id":"client-sites","attributes":_vm.clientSitesAttributes},on:{"changed":_vm.changed}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }